import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [state, setState] = useState("checking");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) { setState("invalid"); return; }
    api.get(`/auth/reset-link/${token}`)
      .then(({ data }) => { setEmail(data.email); setState("valid"); })
      .catch(() => setState("invalid"));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords do not match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-link", { token, new_password: password });
      toast.success("Password set. Please log in.");
      navigate("/login");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (state === "checking") return <AuthShell title="Set new password"><p className="text-center text-sm text-slate-500">Checking link…</p></AuthShell>;
  if (state === "invalid") return <AuthShell title="Set new password"><p className="text-center text-sm text-rose-600" data-testid="reset-invalid">This reset link is invalid or has expired.</p></AuthShell>;

  return (
    <AuthShell title="Set a new password" subtitle={email}>
      <form onSubmit={submit} className="space-y-4" data-testid="reset-link-form">
        <div>
          <Label htmlFor="rnp">New password</Label>
          <Input id="rnp" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)}
            className="mt-1.5" placeholder="Min. 8 characters" data-testid="reset-password" />
        </div>
        <div>
          <Label htmlFor="rcp">Confirm password</Label>
          <Input id="rcp" type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)}
            className="mt-1.5" data-testid="reset-confirm" />
        </div>
        <Button type="submit" className="w-full" disabled={loading} data-testid="reset-submit">
          {loading ? "Saving…" : "Set password"}
        </Button>
      </form>
    </AuthShell>
  );
}
